import axios from 'axios'
import { local } from 'store2'
import { url } from './url_service'
import { oauth } from './oauth_admin_service'

const TOKEN_EXPIRATION_KEY = '__token-expires__'

class AuthService {
  _me: any

  constructor() {
    this._me = null
  }

  get data() {
    return this._me
  }

  logged() {
    let expires = local.get(TOKEN_EXPIRATION_KEY, 0)
    return expires > 0 && expires - Date.now() > 10000
  }

  can(permission: string): Boolean {
    return this._me.scopes?.includes(permission) || this._me.scopes?.includes('any')
  }

  // refreshNeeded() {
  //   let expires = local.get(TOKEN_EXPIRATION_KEY, 0)
  //   return expires > 0 && expires - Date.now() < 10000
  // }

  async refresh() {
    const response = await axios.get(url.create('/internal/auth/refresh'))
    local.set(TOKEN_EXPIRATION_KEY, Date.now() + (response.data.ttl * 1000))
  }


  async authenticate(credenciales: object, isGuest: boolean = false) {
    const response = await axios.post(url.create('/internal/auth/login'), credenciales, {
      params: {
        isGuest
      }
    })
    local.set(TOKEN_EXPIRATION_KEY, (Date.now() + response.data.ttl * 1000))
    return response.data.token
  }

  async loadData() {
    if (!this._me) {
      this._me = (await axios.get(url.create('/internal/auth/me'))).data
    }
    return true
  }


  async unAuthenticate() {
    await oauth.logout()
    await axios.get(url.create('/internal/auth/logout'))
    local.remove(TOKEN_EXPIRATION_KEY)
    this._me = null
  }

}

export default AuthService

// Export auth
export const auth = new AuthService()
